var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMy01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#CCC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.044 15.242a1.3 1.3 0 0 1 1.225-.867h11.462c.55 0 1.042.347 1.225.867L22.5 22.45h-19zM13 13.06a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5"
}))));
export default SvgIconMy01;